// Build "legacy": compatible con Webpack 4 / Babel del proyecto (sin private fields #)
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf'

pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/legacy/build/pdf.worker.min.js')

export default pdfjsLib
